import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildingBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBuildingBlocks"><Path fillRule="evenodd" clipRule="evenodd" d="M2.25 18.1652L10.1434 22.6049V18.9779L2.25 14.5381V18.1652ZM11.5353 18.9495V22.5108L21.75 15.8722V12.3097L11.5353 18.9495ZM2.25 12.9422L10.1434 17.3819V13.7549L2.25 9.31513V12.9422ZM11.5353 13.7265V17.2879L21.75 10.6492V7.08675L11.5353 13.7265ZM2.89607 8.08306L10.8121 12.5353L21.1028 5.84675L13.1867 1.39453L2.89607 8.08306Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBuildingBlocks;
